import { useState } from 'react'

import { MembersDropdown } from '../../../../../components/shared/members-dropdown'
import type { ShipmentStatusEnum, TShipmentMember } from '../../../../../types/shipment'
import { DriversList } from './drivers-list'

interface IShipmentDrivers {
  selectedUsers: TShipmentMember[]
  shipmentID: string
  shipmentNumber: string
  shipmentStatus: ShipmentStatusEnum
  workspaceID: string
}

/**
 * This component is used to display a dropdown to select drivers for a shipment.
 */
export const ShipmentDrivers = ({
  selectedUsers,
  shipmentID,
  shipmentNumber,
  shipmentStatus,
  workspaceID
}: IShipmentDrivers) => {
  const [isOpen, setIsOpen] = useState(false)

  const handleOpenChange = () => {
    setIsOpen(!isOpen)
  }

  const selectedUsersAvatar = selectedUsers.map((user) => {
    return {
      ...user.user
    }
  })

  return (
    <div className="relative w-full">
      <MembersDropdown
        isOpen={isOpen}
        handleOpenChange={handleOpenChange}
        buttonText={'Add Drivers'}
        selectedUsersAvatar={selectedUsersAvatar}
        popoverContent={
          <DriversList
            drivers={selectedUsers}
            onClose={handleOpenChange}
            shipmentID={shipmentID}
            shipmentNumber={shipmentNumber}
            workspaceID={workspaceID}
            shipmentStatus={shipmentStatus}
          />
        }
      />
    </div>
  )
}
